<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card class="pa-1 mb-1">

        <v-card-actions class="py-0">
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-text-field placeholder="Введите телефон в формате 79174696236" v-model="phone"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea placeholder="Напишите текст" v-model="text"></v-textarea>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field placeholder="Ссылка" v-model="url"></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-actions>
    </v-card>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
    name: 'ToolWaMessageConstructor',
    data() {
        return {
            clientFormShow: false,
            clientId: null,
            active: [],
            avatar: null,
            open: [],
            users: [],
            loading: true,
            phone: '',
            text: ''
        }
    },
    props: [],
    methods: {
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        },
        selected() {
            if (!this.active.length) return undefined

            const id = this.active[0]
            return 1
        },
        loadClient(clientId) {
            this.clientId = clientId
            let client
            if (this.$store.state.clients.clients.length > 0) {
                client = this.$store.state.clients.clients.find(client => client.user_id === clientId)
            }
            if (!client) {
                this.$store.dispatch('clients/getClient', { user_id: clientId }).then(response => {
                    this.clientFormShow = true
                })
            } else {
                this.clientFormShow = true
            }
        }
    },
    computed: {
        ...mapGetters({
            moduleGroups: 'api/moduleGroups',
            getBotById: 'bots/getBotById',
            loadedBots: 'bots/loadedBots'// ,
            // tree: 'clients/tree'
        }),
        tree() {
            return this.$store.state.clients.tree.filter(branch => branch.children)
        },
        url() {
            return encodeURI('https://api.whatsapp.com/send?phone=' + this.phone + '&text=' + this.text)
        }
    },
    watch: {},
    created() {
        this.$store.dispatch('clients/getTree', { bot_id: this.$route.params['pathMatch'] }).then(() => {
            this.loading = false
        })
    }
}
</script>

<style scoped>

</style>
